import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditionsView = (props) => {
  return (
    <div>
      <h1 className="terms-header">{props.terms.title}</h1>
      <div>
        {props.terms.sections.map((section, index) => (
          <div key={index}>
            <h4>{section.sectionHeader}</h4>
            <div className="terms-content" dangerouslySetInnerHTML={{ __html: section.sectionContent }} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TermsAndConditionsView;
